import React from 'react';
import cls from 'classnames';
import { capitalize } from 'lodash-es';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import './index.scss';
import { IconButton } from '../FormElements';

const Chip = ({
    color = 'light',
    text,
    onRemove,
    className = '',
    ...restProps
}) => (
    <div
        className={cls('chip border', className, {
            'bg-light': color === 'light',
            'bg-info': color === 'info',
            'bg-white': color === 'white',
        })}
        {...restProps}
    >
        <span className="text-truncate">{text}</span>

        {Boolean(onRemove) && (
            <IconButton
                className={`color${capitalize(color)} ml-1`}
                size="sm"
                onClick={(e) => {
                    e.stopPropagation();
                    onRemove();
                }}
            >
                <FontAwesomeIcon icon={faTimes} />
            </IconButton>
        )}
    </div>
);

export default Chip;